import './AdBanner.css';

export function AdBanner() {
    return (
        <div className="ad-banner">
            <div className="ad-content">
                <p className="ad-label">Реклама</p>
                <a href="https://www.chessbase.ru/?check=48" target="_blank" rel="nofollow">
                    <img
                        src="./728x90_2.jpg"
                        alt="ChessBase.ru"
                        style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
                    />
                </a>
            </div>
        </div>
    );
}
